import styled from 'util/style'

const Title = styled.h1`
  margin: 0;
  font-family: 'Slowly-Two', sans-serif !important;
  text-align: center;
  padding: 30px 0 30px 20px;
  z-index: 2;

  @media (max-width: 640px) {
    padding: 0 10px 10px 15px;
  }

  & * {
    color: #333;
    font-size: 80px;
    font-weight: normal;
    text-decoration: none;

    @media (max-width: 640px) {
      font-size: 40px
    }
  }
`

export default Title
